import {getter, setter} from '@stencil/client-side-storage';
import {cleanAndMergeRsEntries} from './recent-search-utils';

const getStorageKey = isDayUse => {
  return isDayUse ? 'go_dayuse_home_searches' : 'go_home_searches';
};

export function updateRecentSearch({
  destination,
  locus,
  hotelName = '',
  hotelCode = '',
  checkin,
  checkout,
  roomString,
  partner,
  country,
  isDayUse = false,
  checkinTime,
  url = '',
  openSRPForHotelSearch = false,
}) {
  const storageKey = getStorageKey(isDayUse);

  // If destination object has no name and no id, do nothing
  if (!(destination.n && destination._id)) {
    return;
  }

  let searchesList = getter(storageKey) || [];

  let targetDestination = {...destination, t: destination.t};

  if (openSRPForHotelSearch && hotelCode && destination.t === 'city') {
    targetDestination['hotelId'] = hotelCode;
  } else if (hotelName && hotelCode) {
    targetDestination = {
      n: hotelName,
      _id: hotelCode,
      t: 'hotel',
      dest: destination,
    };
    if (destination.mmtId) {
      targetDestination.mmtId = destination.mmtId;
    }
  }

  const newEntry = {
    checkin,
    roomString,
    destination: targetDestination,
    locus,
    partner,
    country,
    isDayUse,
    url,
  };

  if (!isDayUse) {
    newEntry.checkout = checkout;
  } else {
    // For day use, consider checkin and checkout same day if not provided
    // If your logic already ensures checkout for day-use, this may not be needed
    newEntry.checkinTime = checkinTime;
  }

  // Add new entry at the beginning
  searchesList.unshift(newEntry);

  // Clean and merge entries in one go
  searchesList = cleanAndMergeRsEntries(searchesList);

  // Trim list length
  const maxLength = 10;
  searchesList.splice(maxLength);

  setter(storageKey, searchesList);
}

export function getRecentSearch(isDayUse = false) {
  const storageKey = getStorageKey(isDayUse);
  return getter(storageKey);
}
